/*@ngInject*/
const DeleteUserImageRepository = function ($cacheFactory, baseRepository, currentUserModel) {

    angular.extend(this, baseRepository);

    this.deleteUserImage = function (ile) {
        let url = '/rest/User/' + currentUserModel.getCurrentUser().userId + '/deleteUserImage',
            cacheKey = 'userProfile:' + currentUserModel.getCurrentUser().userId;

        return this.delete(url).then(function (responseData) {
            $cacheFactory.get('loadProfileImageCache').remove(cacheKey);

            return responseData;
        });
    };
};

angular.module('umCore')
    .service('deleteUserImageRepository', DeleteUserImageRepository);
